import { create } from "zustand";

const getInitialState = () => {
  const token = localStorage.getItem("token");
  const storedUser = localStorage.getItem("user");

  let user = null;
  let onboardingCompleted = false;
  let onboardingSkipped = false;

  if (storedUser) {
    try {
      user = JSON.parse(storedUser);
      onboardingCompleted =
        user?.onboarding_completed || user?.onboardingCompleted || false;
      onboardingSkipped =
        user?.onboarding_skipped || user?.onboardingSkipped || false;
    } catch (e) {
      console.warn("Failed to parse stored user data:", e);
    }
  }

  return {
    user,
    token,
    isAuthenticated: Boolean(token),
    onboardingCompleted,
    onboardingSkipped,
  };
};

export const useUserStore = create((set) => ({
  ...getInitialState(),
  setAuthFromResponse: (response) =>
    set((state) => {
      if (!response) return state;

      const { user, token } = response;

      if (token) {
        localStorage.setItem("token", token);
      }
      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      return {
        ...state,
        user: user || null,
        token: token || null,
        isAuthenticated: Boolean(token),
        onboardingCompleted:
          user?.onboarding_completed || user?.onboardingCompleted || false,
        onboardingSkipped:
          user?.onboarding_skipped || user?.onboardingSkipped || false,
      };
    }),

  saveUserData: (userData) =>
    set((state) => {
      const { address, email, userId, token, ...rest } = userData;

      const user = {
        ...state.user,
        wallet_address: address,
        email: email || state.user?.email,
        id: userId || state.user?.id,
        ...rest,
      };
      localStorage.setItem("user", JSON.stringify(user));

      if (token) {
        localStorage.setItem("token", token);
      }

      return {
        ...state,
        user,
        token: token || state.token,
        isAuthenticated: Boolean(token || state.token),
      };
    }),
  updateUser: (partialUser) =>
    set((state) => {
      if (!state.user) return state;
      const updatedUser = { ...state.user, ...partialUser };
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return { ...state, user: updatedUser };
    }),
  setOnboardingCompleted: () =>
    set((state) => {
      const user = state.user
        ? {
            ...state.user,
            onboarding_completed: true,
            onboarding_skipped: false,
          }
        : state.user;

      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      return {
        ...state,
        user,
        onboardingCompleted: true,
        onboardingSkipped: false,
      };
    }),

  // Mark onboarding skipped
  skipOnboarding: () =>
    set((state) => {
      const user = state.user
        ? {
            ...state.user,
            onboarding_completed: false,
            onboarding_skipped: true,
          }
        : state.user;

      if (user) {
        localStorage.setItem("user", JSON.stringify(user));
      }

      return {
        ...state,
        user,
        onboardingCompleted: false,
        onboardingSkipped: true,
      };
    }),

  // Clear all auth data
  clearAuth: () =>
    set(() => {
      localStorage.removeItem("token");
      localStorage.removeItem("user");

      return {
        user: null,
        token: null,
        isAuthenticated: false,
        onboardingCompleted: false,
        onboardingSkipped: false,
      };
    }),
}));
